/**
 * dev  : zhihuaw
 * desc : 榜单聚合页ui层组件
 * props: topListData、houseData、payLoad
 * emit : action：动作改变触发钩子
 */
<template>
  <section class="card-list">
    <div class="card-item" @click="gotoCmsDetail">
      <img class="card-item__img" :src="`${picHost}${topListData.activityImg}`" alt>
      <div class="card-item__top clearfix">
        <h4>#{{topListData.activityTitle|filterItem(13)}}</h4>
      </div>
      <div class="card-house">
        <div class="card-house__item" v-for="(itunes,idx) in filterHouseListCpd" :key="idx">
          <img :src="itunes.defaultPicture" @error="imgErrorHandle" alt>
          <p>{{itunes.unitName|filterItem(38)}}</p>
          <div class="card-tag clearfix">
            <div class="card-tag-item" v-for="(itag,ikey) in itunes.labels" :key="ikey"><span ref="tagDom">{{itag.substring(0,8)}}</span></div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>

export default {
  name: 'topList',
  data() {
    return {
      isWxmp: this.platformEnv.isMpEnv
    }
  },
  props: {
    /**
     * [榜单数据]
     */
    topListData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    /**
     * [房屋数据]
     */
    houseData: {
      type: Array,
      default: () => {
        return []
      }
    },
    /**
     * [payload 组件需要的数据体]
     */
    payLoad: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  components: {},
  computed: {
    /**
     * [filterHouseListCpd 只展示cmsid列表中未下架房屋的前两项]
     */
    filterHouseListCpd() {
      const arr = this.houseData.filter((item, index) => {
        return item.unitName
      })
      return arr.filter((item, index) => {
        return index < 2
      })
    },
    /**
     * [是否安卓(安卓用line-height时居中有偏差)]
     */
    isAndriod() {
      const ua = navigator.userAgent
      // android终端
      const isAndroid = ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1

      return isAndroid
    },
    isShowFavIcon() {
      return process.env.VUE_APP_LOCAL !== 'Q'
    },
    mayiIsShowUi() {
      // 蚂蚁所有环境和小程序环境不展示收藏按钮和“xx人正在关注”文案
      return process.env.VUE_APP_LOCAL !== 'M' && !this.isWxmp
    }
  },
  watch: {
    /**
     * [filterHouseListCpd改变时]
     * TODO: 如果安卓，将tag往下移1px
     */
    filterHouseListCpd(newValue, oldValue) {
      if (newValue.length) {
        this.$nextTick()
          .then(() => {
            if (this.isAndriod) {
              if (this.$refs.tagDom && this.$refs.tagDom.length) {
                this.$refs.tagDom.forEach((item) => {
                  item.style.top = '1px'
                })
              }
            }
          })
      }
    }
  },
  methods: {
    /**
     * [gotoCmsDetail 前往cms详情页]
     */
    gotoCmsDetail() {
      this.$emit('action', { type: 'location', data: { activityId: this.topListData.activityId, activityTitle: this.topListData.activityTitle } })
    },
    /**
     * [imgErrorHandle 图片无法展示显示默认图片]
     * @param event 事件默认的event对象
     */
    imgErrorHandle($event) {
      $event.target.src = `${this.baseUrl}static/imgs/default.jpg`
    }
  },
  filters: {
    /**
     * [filterItem 文字处理]
     * TODO： [特殊处理文字]
     */
    filterItem(word, length) {
      if (word) {
        if (word.length > length) {
          return word.substring(0, length - 1) + '...'
        }
        return word
      }
      return ''
    }
  }
}
</script>
<style lang="scss" scoped>
.clearfix {
  zoom: 1;
}
.clearfix:after {
  content: '.';
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}

.card-list {
  padding: 0 1.33rem;
  margin-top: 1.66rem;
}
.card-item {
  width: 100%;
  background: #ffffff;
  box-shadow: 0 2px 60px 5px rgba(0, 0, 0, 0.07);
  border-radius: 6px;
  position: relative;
  padding-bottom: 1rem;
  border-radius: 6px;
  .card-item__img {
    border-radius: 6px 6px 0 0;
    width: 100%;
    height: 11.2rem;
    min-height: 11.2rem;
    background: pink;
    object-fit: cover;
  }
  .card-item__top {
    position: absolute;
    top: 1.33rem;
    font-family: PingFangSC-Medium;
    color: #ffffff;
    width: 100%;
    h4 {
      float: left;
      background-image: linear-gradient(-135deg, #ffbf4f 0%, #ff8d19 100%);
      border-radius: 0px 50px 50px 0px;
      height: 1.86rem;
      line-height: 1.96rem;
      padding: 0 1rem;
      font-size: 1.06rem;
      letter-spacing: 1px;
      margin-left: -6px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
    .item-favor {
      width: 1.66rem;
      height: 1.66rem;
      float: right;
      background-size: cover;
      margin-right: 0.73rem;
      margin-top: 0.13rem;
      position: relative;
      span {
        font-size: 0.66rem;
        position: absolute;
        top: 1.8rem;
        left: 0;
        right: 0;
        margin: 0 auto;
        text-align: center;
      }
    }
  }
  .card-focus {
    position: absolute;
    top: 3.86rem;
    left: 1rem;
    font-family: PingFangSC-Medium;
    font-size: 0.66rem;
    color: #ffffff;
    letter-spacing: -0.42px;
  }
  .card-house {
    padding: 0 0.66rem;
    display: flex;
    position: relative;
    margin-top: -3.33rem;
    .card-house__item {
      flex: 1;
      justify-content: space-between;
      &:nth-child(2) {
        margin-left: 10px;
      }
      img {
        width: 100%;
        height: 6.66rem;
        border-radius: 6px;
        min-height: 6.66rem;
        min-width: 100%;
      }
      p {
        margin-top: 0.66rem;
        font-family: PingFangSC-Medium;
        font-size: 0.93rem;
        line-height: 1.25rem;
        color: #333333;

        height: 2.5rem;
        overflow:hidden;
        text-overflow:ellipsis;
        display:-webkit-box;
        -webkit-box-orient:vertical;
        -webkit-line-clamp:2;
        word-break: break-all;
      }
    }
  }
  .card-tag {
    margin-top: 0.2rem;
    font-family: SourceHanSansCN-Normal;
    font-size: 0.66rem;
    color: #999999;
    max-height: 1.6rem;
    overflow: hidden;
    .card-tag-item {
      padding: 2px 0.33rem;
      border: 1px solid #999999;
      border-radius: 2px;
      margin-top: 0.33rem;
      margin-right: 0.33rem;
      text-align: center;
      float: left;
      span{
        position: relative;
        top: 0.5px;
      }
      // 房屋标签可能很多字
      // &:nth-child(3n) {
      //   margin-right: 0px;
      // }
    }
  }
}
</style>
